<div class="p-3">
    <div class="col-12 col-md-6">
        <h3>Domain Setup</h3>
        <hr class="mb-3" />
        <table class="table">
            <tbody>
                <tr>
                    <td>Domain</td>
                    <td>{{domain.domain}}</td>
                </tr>
                <tr>
                    <td colspan="2">
                        <div class="card">
                            <div class="card-body">
                                <h2 class="mb-1">
                                    Point your domain to this server ip, please take note that there are domain
                                    progoration period of 24 hours after you setup the domain. <br />
                                    <small class="text-muted">请将您的域名解析到此服务器 IP，请注意域名解析需要24小时才能生效。</small>
                                </h2>
                                <span
                                    class="badge bg-primary badge-pill badge-lg fw-bold fs-1 mb-1">{{domain.ip_address}}</span>
                                <p>
                                    You are required to point your domain to this server ip to ensure the domain is
                                    working properly.<br />
                                    <span class="text-muted">您需要将您的域名解析到此服务器 IP，以确保域名能够正常工作。</span>
                                </p>
                                <p>
                                    If you are not sure how to point your domain to this server ip, please contact your
                                    domain registrar and ask them to point your domain to this server ip.<br />
                                    <span class="text-muted">如果您不清楚如何将域名解析到此服务器 IP，请联系您的域名注册商，要求他们将您的域名指向此服务器 IP。</span>
                                </p>
                                <h4 class="mb-0 fw-bold">Example:</h4>
                                <p>Namecheap Domain Pointing Instructions: <br />
                                    <a href="https://www.namecheap.com/support/knowledgebase/article.aspx/9837/46/how-to-connect-a-domain-to-a-server-or-hosting/#viaip"
                                        target="_blank">Read More</a>
                                </p>
                                <p>Godaddy Domain Pointing Instructions: <br />
                                    <a href="https://pressable.com/knowledgebase/how-to-point-godaddy-dns-records-to-pressable/#:~:text=place%20at%20GoDaddy.-,Log%20into%20your%20GoDaddy%20account%20and%20navigate%20to%20your%20domain,right%20of%20your%20domain%20name.&text=Modify%20the%20existing%20A%20record,one%20of%20your%20Pressable%20IPs.&text=In%20some%20cases%2C%20the%20%E2%80%9Cwww,and%20not%20a%20CNAME%20record."
                                        target="_blank">Read More</a>
                                </p>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>Own SSL Certificate</td>
                    <td>{{domain.own_ssl_certificate == 1 ? 'Yes' : 'No'}}</td>
                </tr>
                <ng-container *ngIf="domain.own_ssl_certificate == 1">
                    <tr>
                        <td>SSL Certificate</td>
                        <td>
                            <pre class="text-muted p-3 border">{{domain.cert}}</pre>
                        </td>
                    </tr>
                    <tr>
                        <td>SSL Certificate Private Key</td>
                        <td>
                            <pre
                                class="text-muted p-3 border">SSL Certificate Private Key: <br/>{{domain.cert_private}}</pre>
                        </td>
                    </tr>
                </ng-container>
                <tr>
                    <td>IP Address</td>
                    <td>{{domain.ip_address}}</td>
                </tr>
                <tr>
                    <td>Referral Code</td>
                    <td>{{domain.referral_code ?? 'N/A'}}</td>
                </tr>
                <tr>
                    <td>Status</td>
                    <td>{{domain.status == 1 ? 'Active' : 'Disabled'}}</td>
                </tr>
            </tbody>
        </table>



        <div class="d-flex flex-column gap-2 mb-3">
            <button type="button" class="btn btn-warning" (click)="setupDomain()" [disabled]="setup_domain">Setup
                Domain</button>
            <p class="text-center">This step is to configure the domain in the server.</p>
            <div class="card shadow-lg" *ngIf="setup_domain" style="border: 1px solid #444;">
                <div class="card-body p-0">
                    <div class="d-flex align-items-center justify-content-between p-3 bg-dark text-white border-bottom" style="background-color: #1a1a1a !important;">
                        <h5 class="mb-0 fw-bold">Domain Setup Progress</h5>
                        <button type="button" class="btn btn-sm btn-outline-light" (click)="setup_domain = false">Close</button>
                    </div>
                    <div class="p-3" style="background-color: #1a1a1a !important;">
                        <h6 class="text-muted mb-3" style="font-size: 0.85rem;">
                            Domain Setup Status: You could refer to below status to check on the progress.
                            <br>
                            <span class="text-muted small">域名设置状态：您可以参考下方状态来检查进度。</span>
                        </h6>
                        <pre class="text-light p-3 rounded w-100" 
                             style="white-space: pre-wrap; font-family: 'Consolas', 'Monaco', 'Courier New', monospace; font-size: 1.1rem; min-height: 300px; background-color: #0d0d0d !important; border: 1px solid #444; line-height: 1.6; color: #e0e0e0 !important;"
                             [innerHtml]="setup_domain_message || '<span class=\'text-muted\'>Initializing setup process...</span>'"></pre>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>